var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loggedIn)?_c('div',[_vm._t("default"),_vm._v(" "),_c('button',{on:{"click":_vm.logOut}},[_vm._v("Log out")])],2):_c('div',{attrs:{"id":"firebaseui-auth-container"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ca8d59f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Auth.vue
// module id = 206
// module chunks = 0